import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router';
import CreateIcon from '@mui/icons-material/Create';
import StarIcon from '@mui/icons-material/Star';
import { getDollarFormat } from 'utils/helpers';
import Button from 'screens/components/basic/Button';
import EditEliteMembership from './EditEliteMembership';


const PatientHeader = (props) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(props.lastOrder);

    return (
        // When clicking the 'View Patient' button on the left column, display the following:
        <div className="row m-0 profile-view-container">
            {/* Patient Image*/}
            <div className="text-center col-md-3">
                <div className="patient-img-container">
                    <img className="patient-profile-view-image" width="333" height="250" src={props.patientPhoto} />
                </div>
            </div>
            {/* Patient Container Info and Menu */}
            <div className="patient-details view-details-data col-md-8">
                <div>
                    <h3 className="view-title mb-0">{props.fullName}</h3>
                    <h5 className="view-subtitle mb-0 mt-0">{props.gender} | {props.age} years old</h5>
                    <h6 className="view-label mb-0 mt-0 pt-5px">ID: {props.patientID}</h6>
                    <div>
                        {props.eliteMemberStartDate && <h5 className="view-label mb-0 mt-0 pt-5px">Elite Member Start Date: {moment(props.eliteMemberStartDate).format("MM-DD-YYYY")}</h5>}
                        {props.eliteMemberEndDate && <h5 className="view-label">Elite Member End Date: {moment(props.eliteMemberEndDate).format("MM-DD-YYYY")}</h5>}
                        {props.eliteMemberStartDate && props.eliteMemberEndDate && (new Date(props.eliteMemberStartDate).getTime() < new Date().getTime()) && (new Date(props.eliteMemberEndDate).getTime() > new Date().getTime()) &&
                            <span className='font_jakarta' style={{ fontSize: "16px", color: "red" }}>
                                Elite Member
                            </span>}
                    </div>
                    {props.canModifyEliteMember && props.eliteMemberStartDate && props.eliteMemberEndDate &&
                        <EditEliteMembership
                            patientID={props.patientID}
                            eliteMemberStartDate={props.eliteMemberStartDate}
                            eliteMemberEndDate={props.eliteMemberEndDate}
                        />}
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 mt-2" style={{ display: "flex", justifyContent: "space-between" }}>
                    {props.accessRole && <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12 col-12 p-0">
                        <label>Total Spent:</label>
                        <p className="view-data text-success">${props.totalSpent}</p>
                    </div>}

                    {!props.showPoints && !props.hideBCRewards &&
                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Points:</label>
                            <p className="view-data primary-color-text">{props.totalPoints}</p>
                        </div>
                    }

                    {!props.hideBCRewards &&
                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Visit Count:</label>
                            <p className="view-data primary-color-text">{props.visitCount}</p>
                        </div>
                    }

                    <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 col-12 p-0">
                        <label>Completed Orders:</label>
                        <p className="view-data primary-color-text">{props.ordersTotal}</p>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 col-12 p-0">
                        <label>Last Order:</label>
                        <p className="view-data primary-color-text">{
                            props.lastOrder !== "No Orders" ?

                                `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`

                                : props.lastOrder
                        }</p>
                    </div>
                    {props.tabValue == "history" ?
                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Total Member Savings:</label>
                            <p className="view-data primary-color-text">{getDollarFormat(props.totalMemberSavings)}</p>
                        </div> : null}

                </div>
            </div>
            <div className='view-btn-container' style={{ top: 20 }}>
                {!props.hideBCRewards && <Button
                    newClass="view-visits-btn"
                    type="IconRemove"
                    label="Visits"
                    name="Visits"
                    icon={<StarIcon />}
                    onTouchTap={() => props.openVisits()}
                />
                }
                {!props.showPoints && !props.hideBCRewards &&
                    <Button
                        newClass="view-points-btn"
                        type="IconRemove"
                        label="Points"
                        name="Points"
                        icon={<StarIcon />}
                        onTouchTap={() => props.openPoints()}
                    />
                }
                <Button
                    newClass="view-edit-btn"
                    type="IconRemove"
                    label="Edit"
                    name="Edit"
                    icon={<CreateIcon />}
                    onTouchTap={() => props.directToPatientEdit()}
                />
            </div>
        </div>
    );
};

export default PatientHeader;
